export interface SolutionRequest {
  entityType?: string;
  category?: string;
  issueDescription: string;
}

export type OnGetSolutionHandler = (question: SolutionRequest) => void;

export enum QueryType {
  ISSUE = 'issue',
  QUESTION = 'question'
}
